import { render } from "./BarcodeView.vue?vue&type=template&id=027a729a&ts=true"
import script from "./BarcodeView.vue?vue&type=script&lang=ts"
export * from "./BarcodeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__